<template>
  <v-form @submit.prevent="handleSubmitForm()">
    <ValidationObserver ref="form">
      <v-card>
        <v-card-title>
          Marca
          <v-spacer></v-spacer>
          <v-btn @click="handleCloseForm()" icon :disable="loading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <v-text-field
              v-model="form.name"
              name="name"
              hint="Preencher nome da marca"
              label="Marca"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
          
          <ValidationProvider name="canonical" rules="required" v-slot="{ errors }">
            <v-text-field
              v-if="form.canonical && brand_id"
              label="Canonical"
              :value="form.canonical"
              readonly
              hint="O campo não pode ser alterado"
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-else
              :disable="loading"
              name="canonical"
              label="Canonical"
              :loading="loading"
              v-model="form.canonical"
              :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleCloseForm()" text :disabled="loading">Cancelar</v-btn>
          <v-btn type="submit" color="primary" :loading="loading">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-form>
</template>

<script>
import { 
  store as storeBrand, 
  update as updateBrand,  
  show as showBrand 
} from "@/services/brands";

export default {
  name: "brand-form",
  props: [ "brand_id" ],
  data: () => ({
    loading: false, 
    items: [],
    form: {}
  }),
  methods: {
    handleCloseForm() {
      this.resertForm();
      this.$emit('close');
    },
    resertForm() {
      this.form = {};
      this.$refs.form.reset();
    },
    async handleSubmitForm() {
      const validation = await this.$refs.form.validate();

      if(validation) {
        this.loading = true;
        try {
          if(this.form.id) {
            await updateBrand(this.form, this.form.id);
            this.$store.commit("sendMessage", {
              text: "Atualizado com sucesso"
            });
          } else {
            await storeBrand({
              ...this.form
            });
            this.$store.commit("sendMessage", {
              text: "Registado com sucesso"
            });
          }

          this.resertForm();
          this.$emit('submit');
        } catch (error) {
          this.$refs.form.setErrors(error.response.data.errors);
          this.$store.commit("sendMessage", {
            text: "Falha ao cadastrar",
            color: "red"
          });
        } finally {
          this.loading = false;
        }
      }
    },
    async getBrand() {
      this.loading = true;
      try {
        const response = await showBrand(this.brand_id);
        this.form = response;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível carregar marca",
          color: "red"
        });
        this.$emit('cancel');
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    brand_id: function(value) {
      if(value == null) return;

      this.getBrand();
    }
  },
  created() {
 
    if(this.brand_id) this.getBrand();
  } 
}
</script>